import { CRM_PIPELINE_API } from 'modules/crm/api/crm-pipeline-api'
import { PipelineStageInterface } from 'modules/crm/types/pipeline-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { DataWithPaginationInterface } from 'shared/types/pagination-interface'

export function usePipelineStageList(id?: number) {
  const { user } = useUser()
  const { fetcher } = useFetch<
    RequestMethodsEnum.get,
    DataWithPaginationInterface<Pick<PipelineStageInterface, 'name' | 'id'>>
  >({ method: RequestMethodsEnum.get })

  const { data: pipelineStage, isLoading } = useControlledSwr(
    () => {
      if (user && id) {
        return `${CRM_PIPELINE_API}/${id}/stages/list-all`
      }
    },
    fetcher,
    undefined,
    !!id,
  )
  return { pipelineStage, isLoading }
}
